import { Flame, Droplets, Mountain, Wind, Trophy, Zap, Activity, Crown, BookOpen } from 'lucide-react';

export const BADGE_TIERS = {
    spark: { 
        id: 'spark', 
        label: 'Spark', 
        color: 'text-orange-400', 
        bg: 'bg-orange-500', 
        icon: Zap,
        desc: "Initiation. Solidify your foundation." 
    },
    flow:  { 
        id: 'flow',  
        label: 'Flow',  
        color: 'text-blue-400',   
        bg: 'bg-blue-500',   
        icon: Activity,
        desc: "Momentum. Direct the energy." 
    },
    apex:  { 
        id: 'apex',  
        label: 'Apex',  
        color: 'text-yellow-400', 
        bg: 'bg-yellow-500', 
        icon: Crown,
        desc: "Mastery. Self-sustaining power." 
    }
};

export const BADGES = [
    // --- TIER 1: SPARK ---
    {
        id: 'ember_keeper',
        tier: 'spark',
        element: 'fire',
        name: 'Ember Keeper',
        desc: 'Logged in 7 days in a row.',
        icon: 'fire'
    },
    {
        id: 'foundation_layer',
        tier: 'spark',
        element: 'earth',
        name: 'First Brick',
        desc: 'Added your first Asset.',
        icon: 'earth'
    },
    {
        id: 'smoke_signal',
        tier: 'spark',
        element: 'fire',
        name: 'Smoke Signal',
        desc: 'Ran a debt payoff simulation.',
        icon: 'fire'
    },
    {
        id: 'first_drop',
        tier: 'spark',
        element: 'water',
        name: 'First Drop',
        desc: 'Added an income source.',
        icon: 'water'
    },
    {
        id: 'spark_watcher',
        tier: 'spark',
        element: 'fire',
        name: 'Spark Watcher',
        desc: 'Tracked 20 transactions.',
        icon: 'fire'
    },
    {
        id: 'visionary',
        tier: 'spark',
        element: 'air',
        name: 'Visionary',
        desc: 'Set a Retirement Age & FI Number.',
        icon: 'air'
    },
    {
        id: 'knowledge_seeker',
        tier: 'spark',
        element: 'air',
        name: 'Knowledge Seeker',
        desc: 'Read all 8 Knowledge Base articles.',
        icon: 'air'
    },

    // --- TIER 2: FLOW ---
    {
        id: 'messenger',
        tier: 'flow',
        element: 'air',
        name: 'The Messenger',
        desc: 'Connected with a friend via their Codename.',
        icon: 'air'
    },
    {
        id: 'controlled_burn',
        tier: 'flow',
        element: 'fire',
        name: 'Controlled Burn',
        desc: 'Committed an extra debt payment to the Burn tab.',
        icon: 'fire'
    },
    {
        id: 'river_guide',
        tier: 'flow',
        element: 'water',
        name: 'River Guide',
        desc: 'Linked an income stream directly to an Asset.',
        icon: 'water'
    },
    {
        id: 'reservoir_guardian',
        tier: 'flow',
        element: 'water',
        name: 'Reservoir Dog',
        desc: 'Fully funded a Sinking Fund.',
        icon: 'water'
    },
    {
        id: 'terraformer',
        tier: 'flow',
        element: 'earth',
        name: 'Terraformer',
        desc: 'Achieved Positive Net Worth (Assets > Debts).',
        icon: 'earth'
    },
    {
        id: 'shield_bearer',
        tier: 'flow',
        element: 'earth',
        name: 'Shield Bearer',
        desc: 'Cash Assets > 3 Months of Expenses.',
        icon: 'earth'
    },
    {
        id: 'tidal_surge',
        tier: 'flow',
        element: 'water',
        name: 'Tidal Surge',
        desc: 'Logged a Bonus or Surge in Water tab.',
        icon: 'water'
    },

    // --- TIER 3: APEX ---
    {
        id: 'extinguisher',
        tier: 'apex',
        element: 'fire',
        name: 'The Extinguisher',
        desc: 'Paid off ALL debt.',
        icon: 'fire'
    },
    {
        id: 'hydro_engineer',
        tier: 'apex',
        element: 'water',
        name: 'Hydro Engineer',
        desc: 'Logged a Perfect Month (Surplus in Tracker).',
        icon: 'water'
    },
    {
        id: 'tectonic_shift',
        tier: 'apex',
        element: 'earth',
        name: 'Tectonic Shift',
        desc: 'Reached $100k Net Worth.',
        icon: 'earth'
    },
    {
        id: 'skywalker',
        tier: 'apex',
        element: 'air',
        name: 'Skywalker',
        desc: 'Reached 10% of your FI Number.',
        icon: 'air'
    },
    {
        id: 'fireproof',
        tier: 'apex',
        element: 'fire',
        name: 'Fireproof',
        desc: '3 Consecutive months of Surplus.',
        icon: 'fire'
    },
    {
        id: 'alchemist',
        tier: 'apex',
        element: 'air',
        name: 'The Alchemist',
        desc: 'Earned all other badges.',
        icon: 'trophy'
    }
];